var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepsol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 32,
    viewBox: "0 0 151 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99006 17.836C7.05056 17.2191 7.14555 16.606 7.2746 15.9996L7.27885 15.9785L7.22789 15.9836C6.30715 16.0765 4.8496 16.1837 3.77767 16.3213C1.89628 16.567 0.183916 16.8144 0.0403697 16.9841C-0.346951 17.44 2.23009 17.7778 6.16106 17.8284C6.42946 17.836 6.70806 17.836 6.99006 17.836Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7667 0C20.5713 0 14.4506 3.48876 10.6802 8.59356C10.6802 8.59356 1.88649 9.22005 1.42187 9.99683C0.033126 12.6362 0 17.0571 0 17.0571L0.00424694 17.0419C0.0120196 17.0219 0.02355 17.0036 0.0382224 16.9879C0.181769 16.819 1.89413 16.5699 3.77553 16.3242C4.85 16.1858 6.305 16.0785 7.22574 15.9865L7.275 15.9806C10.3328 15.68 16.1536 15.2646 19.4841 15.1734C27.645 14.9497 34.683 15.013 39.5628 15.2342C40.9846 6.75293 35.3914 0 26.7667 0Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6919 22.4135C34.1803 22.3899 24.8931 22.3156 20.7642 22.4465C20.7472 22.4465 18.8471 22.5157 18.7894 22.5166C14.3343 22.6972 10.5614 22.9792 7.48828 23.2764C9.05285 28.4361 13.7007 31.968 19.9378 31.968C26.5095 31.968 32.9996 28.0292 36.6936 22.4085L36.6919 22.4135Z",
    fill: "#E52330"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5695 15.2347C34.6889 15.0135 27.6509 14.9485 19.4883 15.1722C16.157 15.2634 10.3285 15.6788 7.27497 15.9794C7.20362 16.3171 7.0949 16.871 7.00996 17.6039C7.00996 17.6174 7.00996 17.6317 7.00996 17.6469C6.98108 17.9002 6.95984 18.1459 6.94455 18.3933C6.94455 18.4085 6.94455 18.4254 6.94455 18.4414C6.92927 18.6838 6.92162 18.9235 6.91992 19.16C6.91992 19.3102 6.91992 19.4597 6.92672 19.6075C6.92672 19.7333 6.92672 19.8608 6.93266 19.9798C6.9437 20.2424 6.96069 20.5058 6.98702 20.7616C6.99382 20.8359 7.00741 20.9094 7.0142 20.9829C7.03884 21.183 7.06262 21.3839 7.09914 21.5806C7.11358 21.6651 7.12887 21.7402 7.14331 21.8196C7.17729 22.0104 7.21466 22.2004 7.25713 22.3861C7.27327 22.4613 7.2911 22.533 7.30979 22.6065C7.35821 22.7999 7.40832 22.9932 7.46438 23.1823C7.47287 23.2153 7.48222 23.2473 7.49326 23.2803C10.5655 22.9797 14.341 22.6977 18.7995 22.5204C18.8547 22.5204 20.753 22.4511 20.7717 22.4486C24.9006 22.3194 34.187 22.3929 36.7011 22.4165L37.3467 22.4216C39.4574 22.4537 40.3195 22.4731 42.5177 22.5905C43.537 22.6445 45.212 22.7078 45.302 22.9282C45.302 22.9358 45.302 22.9282 45.302 22.9358C45.2999 22.9421 45.2973 22.9483 45.2944 22.9544C46.684 20.4011 46.7044 16.1685 46.7044 16.1685C46.7757 15.8012 44.1188 15.4441 39.5797 15.2397",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6917 22.4146C32.9977 28.0353 26.5075 31.9741 19.9358 31.9741C16.9723 31.9741 14.3672 31.177 12.2811 29.7856C9.97758 28.2497 8.30769 25.9903 7.48633 23.2843C10.5594 22.9837 14.3324 22.7017 18.7874 22.5244C18.8452 22.5244 20.741 22.456 20.7614 22.4543C24.8911 22.3234 34.1817 22.3977 36.69 22.4214L36.6917 22.4146Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2069 8.16802C37.6732 8.16802 38.4852 8.16802 39.0441 8.16802C37.3326 3.29288 32.7892 0 26.7662 0C20.5734 0 14.4501 3.49214 10.6797 8.59356C13.3977 8.34026 16.9414 8.14016 20.4154 8.07937C21.0949 8.06839 22.3987 7.79483 23.1334 6.71409C24.4924 4.70628 25.8328 2.67483 27.7405 1.99852C27.7728 1.98501 27.8059 1.9715 27.8399 1.95884C30.7363 0.857836 34.5628 3.53435 37.2069 8.16802Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6914 22.4143C36.0679 22.4084 35.0274 22.3999 33.7517 22.3915C30.7924 22.3746 26.4758 22.3602 23.3993 22.3915C22.7198 22.9428 21.9443 23.7559 21.591 24.4871C19.1974 28.5095 18.3633 32.4533 10.9634 26.4341C10.9634 26.4341 9.78365 26.3269 8.98438 26.4789C9.80023 27.7107 10.8422 28.7789 12.0558 29.6274C12.1466 29.6856 12.2256 29.7371 12.2868 29.781C12.4227 29.8717 12.5609 29.9612 12.7013 30.0495C14.7126 31.2738 17.1674 31.9695 19.9355 31.9695C26.5072 31.9737 32.9974 28.035 36.6914 22.4143Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2967 22.9218C45.2066 22.7031 43.5282 22.6398 42.5124 22.5841C40.3142 22.4684 39.4546 22.4498 37.3421 22.4152L36.689 22.4102C36.3226 22.9674 35.9302 23.5069 35.5117 24.0287C41.313 23.854 45.1327 23.4504 45.2924 22.926C45.2984 22.9201 45.2967 22.9303 45.2967 22.9218Z",
    fill: "url(#paint6_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.353 9.49915C133.808 8.40448 138.395 10.4931 139.228 14.6594C139.811 18.7294 136.66 22.9986 131.376 24.2224C126.376 25.1463 121.561 23.362 120.697 19.292C119.947 15.2549 123.665 10.7909 128.353 9.49915ZM126.671 20.4327C127.922 21.6916 130.409 21.0326 132.234 18.9593C134.059 16.886 134.532 14.18 133.285 12.9211C132.038 11.6622 129.547 12.319 127.72 14.3945C125.893 16.4678 125.42 19.1738 126.671 20.4327ZM101.555 12.3869C101.06 12.1241 100.345 11.9906 99.4086 11.9906H98.4587L97.5572 16.2007H98.318C99.6373 16.2007 100.65 15.9781 101.357 15.5329C102.038 15.1398 102.425 14.3862 102.346 13.6063C102.329 13.0854 102.025 12.6164 101.555 12.3869ZM91.957 23.8677C91.957 23.8677 90.5344 23.9312 90.7279 22.5848L93.2015 11.0142C93.3651 10.3302 93.9649 9.83766 94.6703 9.80783H100.66C101.623 9.8031 102.586 9.86822 103.54 10.0027C104.289 10.1031 105.017 10.3165 105.701 10.6354C106.266 10.9005 106.755 11.3034 107.122 11.8067C107.479 12.3818 107.678 13.04 107.7 13.7158C107.806 15.3374 107.06 16.6458 105.464 17.6413C103.874 18.6396 101.59 19.0162 98.6126 19.0162H96.9658L95.9148 23.8677H91.957ZM68.0499 12.3496C67.6014 12.1103 66.9542 11.9906 66.1084 11.9906H64.7628L63.9492 15.776H65.2861C66.4426 15.776 67.3258 15.5818 67.9356 15.1936C68.5132 14.8545 68.8428 14.2143 68.7821 13.5494C68.7823 13.0447 68.4999 12.582 68.0499 12.3496ZM62.2144 23.8677H58.1797C57.9005 23.8677 56.8473 23.7561 57.0188 22.5848L59.499 11.0142C59.6636 10.3316 60.2633 9.8408 60.9677 9.81223H67.7949C68.662 9.80496 69.5286 9.86204 70.3872 9.983C71.0645 10.0739 71.723 10.2719 72.3375 10.5697C73.4191 11.0587 74.1217 12.1238 74.1427 13.3064C74.2592 14.9221 73.5578 16.0146 72.1176 16.9341C70.7852 17.6325 68.9492 17.7442 68.5095 17.7529C68.5095 17.7529 68.0587 17.8536 68.5776 17.985C69.0061 18.1105 69.4032 18.3246 69.743 18.6133C70.8731 19.5088 71.7021 20.4327 74.2636 23.8677H68.2104C67.2575 22.0697 66.1873 20.3357 65.0068 18.6768C64.5253 17.985 63.747 18.1032 63.4545 18.0704L62.2144 23.859V23.8677ZM146.016 21.153H150.906L150.569 22.7161C150.395 23.3785 149.803 23.8474 149.116 23.8677H141.429C141.15 23.8677 140.099 23.7561 140.268 22.5848L142.748 11.0142C142.914 10.3324 143.513 9.84225 144.217 9.81222H148.465L146.027 21.1595L146.016 21.153ZM82.6541 15.5636H89.0722L88.749 17.0392C88.5866 17.722 87.9887 18.2145 87.2847 18.2455H82.0802L81.4535 21.153H87.8805L87.5441 22.7162C87.3694 23.3773 86.7792 23.8457 86.0929 23.8677H76.8581C76.5811 23.8677 75.5279 23.7561 75.6972 22.5848L78.173 11.0142C78.337 10.33 78.9381 9.83792 79.644 9.81004H90.3123L89.9781 11.3141C89.8148 11.9973 89.2162 12.4896 88.5116 12.5204H83.3005L82.6409 15.5636H82.6541ZM122.012 9.81004L121.689 11.3163C121.542 12.0106 120.932 12.5109 120.22 12.5204H119.881C116.829 12.5314 116.636 13.3589 116.051 16.1788L115.325 19.5263C114.433 23.7889 110.567 23.8699 110.242 23.8699H102.511L102.836 22.3615C102.995 21.6742 103.598 21.1791 104.305 21.1552H106.163C109.215 21.1552 109.409 20.321 109.991 17.5012L110.719 14.1537C111.638 9.90637 116.293 9.81223 117.007 9.81223L122.012 9.81004Z",
    fill: "#041E42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.508121,
    y1: 16.3206,
    x2: -0.483889,
    y2: 18.4193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95C13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E57C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EF950A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F5A408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -15.5845,
    y1: 6.53364,
    x2: -11.0076,
    y2: 31.2831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDCA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F8B21E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6A80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F6A60B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F49E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3900B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F07D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#EC640B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5D0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -22.9157,
    y1: 16.6225,
    x2: -20.8958,
    y2: 33.6301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C5C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D3D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BAB8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A6A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 36.7016,
    y1: 31.9741,
    x2: 36.7016,
    y2: 22.3724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89181E",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B31829",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B01828",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AA1827",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9E1824",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8F181F",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89181E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -1.70836,
    y1: 5.57853,
    x2: 1.94608,
    y2: 19.9832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FECD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6A924",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2970C",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 40.0845,
    y1: 35.0747,
    x2: 41.6636,
    y2: 17.7117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E30335",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CA0A2D",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B21126",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A21520",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#97181D",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#94191C",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96191D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 45.2985,
    y1: 24.033,
    x2: 45.2985,
    y2: 22.4144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D8D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D1D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#BDBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848685"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.87,
    height: 15.25,
    fill: "white",
    transform: "translate(57 9.21094)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepsol);
export default __webpack_public_path__ + "static/media/repsol.a77ec73e176d7f929db63d7ee4f2dc9f.svg";
export { ForwardRef as ReactComponent };